<template>
  <div class="delivery-tab-layout">
    <div
      v-if="loading"
      class="delivery-tab-layout__loader"
    >
      <ui-loader size="60" />
    </div>

    <template v-else>
      <div class="delivery-tab-layout__content">
        <slot />
      </div>

      <div class="delivery-tab-layout__aside">
        <slot name="aside" />
      </div>
    </template>

    <slot name="append" />
  </div>
</template>

<script>
export default {
  name: 'delivery-tab-layout',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.delivery-tab-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  &__aside {
    flex: 1;
    padding-bottom: 32px;
  }

  &__loader {
    display: flex;
    width: 100%;
    margin-top: 20%;
    align-items: center;
    justify-content: center;
    color: $blue;
  }

  &__stub {
    max-width: 288px;

    .title {
      font-size: 16px;
      line-height: 24px;
    }

    .description {
      padding-top: 4px;
      font-size: 14px;
      line-height: 20px;

      span {
        color: $blue;
        cursor: pointer;
      }
    }
  }
}

@include breakpoint("tablet") {
  .delivery-tab-layout {
    &__aside {
      padding-top: 4px;
    }
  }
}

@include breakpoint("desktop") {
  .delivery-tab-layout {
    flex-direction: row;
    width: 100%;

    &__content {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 536px;
      margin-right: 32px;
      overflow: hidden;
    }

    &__aside {
      position: relative;
      width: 100%;
      padding: 0;
    }

    &__loader {
      margin-top: 0;
    }
  }
}
</style>
